export class CorpoDirigente {

  id: number;
  date: Date;
  nome: string;
  cargo: string;
  sobre: string;

  featuredMedia: {
    canvas: MediaDetail,
    thumbnail: MediaDetail,
  };

  public getMedia(): MediaDetail {

    if (!this.featuredMedia) {
      return undefined;
    }

    if (this.featuredMedia.canvas) {
      return this.featuredMedia.canvas;
    } else if (this.featuredMedia.thumbnail) {
      return this.featuredMedia.thumbnail;
    } else {
      return undefined;
    }
  }
}

interface MediaDetail {
  file: string;
  width: number;
  height: number;
  mime_type: string;
  source_url: string;
}
